import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useFeatureRestriction } from "../../context/FeatureRestrictionContext";

interface RouteGuardProps {
  children: React.ReactNode;
}

/**
 * RouteGuard - パスに対する設定制限をチェックし、制限されている場合は制限モーダルを表示するコンポーネント
 */
const RouteGuard: React.FC<RouteGuardProps> = ({ children }) => {
  const location = useLocation();
  const { isFeatureRestricted, showRestrictionModal } = useFeatureRestriction();
  const navigate = useNavigate();
  const [lastAccessiblePath, setLastAccessiblePath] = useState("/");

  // 言語プレフィックスを除去したパスを取得
  const getPathWithoutLanguage = (path: string): string => {
    return path.replace(/^\/[a-z]{2}/, "");
  };

  useEffect(() => {
    const currentPath = getPathWithoutLanguage(location.pathname);

    // スラッシュで始まっていない場合は追加
    const normalizedPath = currentPath.startsWith("/") ? currentPath : `/${currentPath}`;

    // 機能制限をチェック
    if (isFeatureRestricted(normalizedPath)) {
      // 現在のパスが制限されている場合、モーダルを表示し、前のアクセス可能なパスを保持
      showRestrictionModal(normalizedPath, lastAccessiblePath);
    } else {
      // 制限されていないパスの場合、最後にアクセスできたパスとして記録
      setLastAccessiblePath(normalizedPath);
    }
  }, [location.pathname, isFeatureRestricted, showRestrictionModal, navigate, lastAccessiblePath]);

  return <>{children}</>;
};

export default RouteGuard;
